/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraThreatsTrendSummaryRequest extends models.InfraIssuesTimeRangeFilter {
    getFixupPrototypeFunction() { return InfraThreatsTrendSummaryRequest.fixupPrototype; }

    static newInstance(model: Partial<InfraThreatsTrendSummaryRequest>): InfraThreatsTrendSummaryRequest {
        let obj = Object.assign(new InfraThreatsTrendSummaryRequest(), model);
        InfraThreatsTrendSummaryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraThreatsTrendSummaryRequest>): InfraThreatsTrendSummaryRequest {
        if (!model) return null;
        return InfraThreatsTrendSummaryRequest.newInstance(<InfraThreatsTrendSummaryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraThreatsTrendSummaryRequest) {
        if (!obj) return;

        models.InfraThreatsTrendSummaryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraThreatsTrendSummaryRequest): boolean {
        if (models.InfraIssuesTimeRangeFilter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraThreatsTrendSummaryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.SecurityInfraIssuesDashboardFilters.fixupPrototype(this.filters);
        }
    }

    /**
     * Fields to group the infrastructure threat result
     */
    group_by: Array<models.InfraThreatsTrendGroupBy>;

    /**
     * Filters applied to the issues trend data.
     */
    filters: models.SecurityInfraIssuesDashboardFilters;

}
